export default 8.54